import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { DIVISIONS } from '../mock';
import Reveal from './Reveal';

const ROUTES = {
  security: '/divisions/electronic-security',
  manufacturing: '/divisions/contract-manufacturing',
  marketing: '/divisions/multimedia-marketing',
};

const COLOR = {
  cyan: { text: 'text-[#0ef3fe]', border: 'hover:border-[#0ef3fe]/60', shadow: 'hover:shadow-[0_0_40px_rgba(14,243,254,0.25)]', chip: 'bg-[#0ef3fe]/15 text-[#0ef3fe]', ring: 'group-hover:border-[#0ef3fe]/60' },
  magenta: { text: 'text-[#088ffe]', border: 'hover:border-[#088ffe]/60', shadow: 'hover:shadow-[0_0_40px_rgba(8,143,254,0.25)]', chip: 'bg-[#088ffe]/15 text-[#088ffe]', ring: 'group-hover:border-[#088ffe]/60' },
  violet: { text: 'text-[#0a6bd6]', border: 'hover:border-[#0a6bd6]/60', shadow: 'hover:shadow-[0_0_40px_rgba(10,107,214,0.25)]', chip: 'bg-[#0a6bd6]/15 text-[#0a6bd6]', ring: 'group-hover:border-[#0a6bd6]/60' },
};

export default function Divisions() {
  return (
    <section id="divisions" className="relative py-24 px-5">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="text-center mb-16">
            <span className="font-mono-accent text-xs text-[#088ffe]">// WHAT WE DO</span>
            <h2 className="font-display text-4xl md:text-5xl font-bold mt-3">Our Divisions</h2>
            <p className="text-white/55 mt-4 max-w-xl mx-auto">Comprehensive solutions across three core sectors, engineered to move fast and build bold.</p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {DIVISIONS.map((d, i) => {
            const c = COLOR[d.color];
            return (
              <Reveal key={d.id} delay={i * 120}>
                <Link
                  to={ROUTES[d.id] || '#contact'}
                  data-testid={`division-tile-${d.id}`}
                  className={`group relative block h-[420px] overflow-hidden rounded-3xl neon-border border-white/10 transition-all duration-300 ${c.border} ${c.shadow}`}
                >
                  <img src={d.image} alt={d.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a1526] via-[#0a1526]/55 to-transparent" />

                  <span className={`absolute top-5 left-5 font-mono-accent text-[10px] px-3 py-1 rounded-full ${c.chip}`}>{d.tag}</span>

                  <div className="absolute bottom-0 left-0 right-0 p-7">
                    <h3 className="font-display text-2xl font-bold mb-2 text-white">{d.name}</h3>
                    <p className="text-sm text-white/70 leading-relaxed mb-4 line-clamp-3">{d.desc}</p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-white/50">{d.note}</span>
                      <span className={`flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white ${c.ring} transition-colors`}>
                        <ArrowUpRight className="h-5 w-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                      </span>
                    </div>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
